














































































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, institutionServer, performanceServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import AddDialog from '@/views/responsibility/unit/addDialog.vue';
import ViewDialog from '@/views/responsibility/unit/viewDialog.vue';
import DeleteDialog from '@/views/responsibility/unit/deleteDialog.vue';
import FinishDialog from '@/views/responsibility/unit/finishDialog.vue';
import EditDialog from '@/views/responsibility/unit/editDialog.vue';

@Component({
  components: { DeleteDialog, ViewDialog, AddDialog, CollapseTransition, PagingUnit, FinishDialog, EditDialog },
  mixins: [TableStripe],
})
export default class PerformanceManagement extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据

  private timeRange: any = [];
  // 表单数据对象
  formData: any = {
    executeDepartmentIdAndSub: '',
    executeStaffId: '',
    type: '',
    status: '',
    startTime: '',
    endTime: '',
    search: '',
  };
  // table 数据对象
  tableData: any = [];
  // 执行部门
  subSpaceByAuthOptions: any = [];
  // 人员
  spaceStaffByAuthOptions: any = [];
  // 任务
  taskOptions: any = [];

  // 完成状态
  questionOptions: any = [
    {
      label: '待接收',
    },
    {
      label: '待完成',
    },
    {
      label: '待审批',
    },
    {
      label: '已完成',
    },
  ];
  taskId: any = '';

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.taskId = this.$route.params.taskId;
    this.getSubSpaceByAuth();
    this.getTask();
    this.getPageData();
  }
  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuth(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  getChangePost(e: any) {
    this.formData.executeStaffId = '';
    this.spaceStaffByAuthOptions = [];
    if (e) {
      this.getSpaceStaffByAuth(e);
    }
  }

  // 创建开始点击事件
  createExam(type: any, Level: any, data: any) {
    const detailsDialog: any = 'detailsDialog';
    const detailsDialogRef: any = this.$refs[detailsDialog];
    detailsDialogRef.showAddDialog(type, Level, data);
  }

  // 打开删除事件
  openDeletedialog(pId: any) {
    const deleteDialog: any = 'deleteDialog';
    const deleteDialogRef: any = this.$refs[deleteDialog];
    deleteDialogRef.showAddDialog(pId);
  }

  // 查看
  viewManagement(data: any) {
    const viewDialog: any = 'viewDialog';
    const viewDialogRef: any = this.$refs[viewDialog];
    viewDialogRef.showDialog(data);
  }

  // 完成
  openFinishdialog(id: any, index: any) {
    const finishDialog: any = 'finishDialog';
    const finishDialogRef: any = this.$refs[finishDialog];
    finishDialogRef.showDialog(id, index);
  }
  // 编辑
  editDialog(id: any) {
    const EditDialog: any = 'EditDialog';
    const EditDialogRef: any = this.$refs[EditDialog];
    EditDialogRef.showDialog(id);
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getPerformanceList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        executeDepartmentIdAndSub: this.formData.executeDepartmentIdAndSub ? this.formData.executeDepartmentIdAndSub : null,
        executeStaffId: this.formData.executeStaffId ? this.formData.executeStaffId : null,
        type: this.formData.type ? this.formData.type : null,
        status: this.formData.status ? this.formData.status : null,
        startTime: this.timeRange ? (this.timeRange[0] ? this.timeRange[0] : null) : null,
        endTime: this.timeRange ? (this.timeRange[1] ? this.timeRange[1] : null) : null,
        mainTaskId: this.taskId ? this.taskId : null,
        search: this.formData.search ? this.formData.search : null,
      })
      .then((res: any) => {
        // this.tableData = arrayToTree(res.data);
        this.tableData = res.data.records;
        this.tableData.forEach((item: any, index: any) => {
          item.isIndex = true;
          item.parentIndex = index + 1;
          if (item.children && item.children.length > 1) {
            item.children = item.children.sort(this.dateDate('startTime', true));
          }
        });
        // --------------- 处理序号 ---------//
        // for (let i=0;i<this.tableData.length;i++) {
        //   this.tableData[i].index = i + 1;
        // }
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 子任务排序
  dateDate(property: any, type: any) {
    return function(a: any, b: any) {
      const value1 = a[property];
      const value2 = b[property];
      if (type) {
        return Date.parse(value1) - Date.parse(value2);
      } else {
        return Date.parse(value2) - Date.parse(value1);
      }
    };
  }

  /**
   * @desc 获取任务类型数据
   * @param1 暂无
   * @returns 暂无
   */
  getTask() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('dutyTaskType')
      .then((res: any) => {
        for (const i in res.data) {
          this.taskOptions.push({
            value: i,
            label: res.data[i],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  getTime(newDate: any) {
    const date = new Date(newDate); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    // const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    // const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // const Ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return SY + '-' + SM + '-' + SD;
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      executeDepartmentIdAndSub: '',
      executeStaffId: '',
      type: '',
      status: '',
      startTime: '',
      endTime: '',
      search: '',
    };
    this.timeRange = [];
    this.getPageData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断完成状态从而给出背景颜色。
   * @param1 传入 完成状态 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  setStateColor(state: any) {
    switch (state) {
      case '已完成':
        return '#19dd19';
        break;
      case '待审批':
        return '#FF8F1B';
        break;
      case '待接收':
        return '#FF2F2F';
        break;
      case '待完成':
        return '#4C64FE';
        break;
    }
  }
}
